"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("../style.css"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var DndArrows = function DndArrows() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].dndArrows
  }, /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null), /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null));
};
var _default = DndArrows;
exports["default"] = _default;